<div class="modal-container agent-skip-kyc-modal">
  <div class="modal-header">
    <h2>{{ 'KYC.SKIP.MODAL_TITLE' | translate }}</h2>
    <button
      mat-icon-button
      type="button"
      (click)="onCancel()"
      class="close-button"
      [disabled]="saving"
      [attr.aria-label]="'KYC.SKIP.CANCEL' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-content">
    <!-- ================================= -->
    <!-- PHASE: SELECT REASON              -->
    <!-- ================================= -->
    <ng-container *ngIf="phase === 'SELECT'">
      <div class="content">
        <p class="description">
          {{ 'KYC.SKIP.MODAL_INTRO' | translate }}
        </p>

        <div class="input-section">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ 'KYC.SKIP.REASON_LABEL' | translate }}</mat-label>
            <mat-select
              [(value)]="selectedReason"
              [disabled]="saving"
              panelClass="agent-skip-kyc-panel">
              <mat-option *ngFor="let reason of reasons" [value]="reason">
                {{ 'KYC.SKIP.REASONS.' + reason | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div *ngIf="error" class="error-message">
            <mat-icon>error</mat-icon>
            <span>{{ 'KYC.SKIP.ERROR_GENERIC' | translate }}</span>
          </div>
        </div>

        <div class="actions space-between">
          <button
            class="def-button outline"
            type="button"
            (click)="onCancel()"
            [disabled]="saving">
            {{ 'KYC.SKIP.CANCEL' | translate }}
          </button>
          <button
            class="def-button black"
            type="button"
            (click)="onSave()"
            [disabled]="!selectedReason || saving">
            <mat-spinner
              *ngIf="saving"
              diameter="20"
              style="display: inline-block; margin-right: 8px;">
            </mat-spinner>
            {{ saving ? ('KYC.SKIP.SAVING' | translate) : ('KYC.SKIP.SAVE' | translate) }}
          </button>
        </div>
      </div>
    </ng-container>

    <!-- ================================= -->
    <!-- PHASE: POST-SAVE CALLOUT          -->
    <!-- ================================= -->
    <ng-container *ngIf="phase === 'POST_SAVE'">
      <div class="content centered-text post-save">
        <div class="callout warn">
          <mat-icon class="callout-icon">campaign</mat-icon>
          <div class="callout-body">
            <p class="callout-title">{{ 'KYC.SKIP.POST_SAVE_TITLE' | translate }}</p>
            <p class="callout-message">{{ 'KYC.SKIP.POST_SAVE_GENERIC' | translate }}</p>
          </div>
        </div>

        <div class="actions center">
          <button
            class="def-button black"
            type="button"
            (click)="onAcknowledgePostSave()">
            {{ 'KYC.SKIP.CONTINUE' | translate }}
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
